import React, { useState } from "react";
import axiosBackend from "../api/axiosBackend";
import AutocompleteTagInput from "../components/AutocompleteTagInput";

// shadcn
import { Button } from "components/ui/button";
import { Input } from "components/ui/input";
import { Textarea } from "components/ui/textarea";
import { Label } from "components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogTrigger } from "components/ui/dialog";
import { Card, CardContent } from "components/ui/card";

function InsertOrderForm({ onCreated, onClose }) {
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [product, setProduct] = useState("");
  const [comments, setComments] = useState("");
  const [selectedTags, setSelectedTags] = useState([]);
  const [submitting, setSubmitting] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const resetForm = () => {
    setName("");
    setPhone("");
    setProduct("");
    setComments("");
    setSelectedTags([]);
    setErrorMsg("");
  };

  const validate = () => {
    if (!name.trim()) return "שם חובה";
    if (!phone.trim()) return "מספר פלאפון חובה";
    return "";
  };

  const handleAddOrder = async () => {
    const v = validate();
    if (v) {
      setErrorMsg(v);
      return;
    }
    setSubmitting(true);
    setErrorMsg("");
    try {
      const payload = {
        name,
        phone,
        product,
        comments,
        tags: selectedTags.map((t) => t._id),
      };
      const response = await axiosBackend.post("/orders/add", payload);
      // optional callback to parent
      onCreated?.(response.data.data);
      resetForm();
      onClose?.(); // close dialog if provided
    } catch (error) {
      console.error("Error adding order:", error);
      setErrorMsg("אירעה שגיאה בעת יצירת ההזמנה");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="space-y-4" dir="rtl">
      <div className="grid grid-cols-1 gap-3">
        <div className="space-y-1">
          <Label htmlFor="name">שם</Label>
          <Input id="name" value={name} onChange={(e) => setName(e.target.value)} />
        </div>

        <div className="space-y-1">
          <Label htmlFor="phone">מספר פלאפון</Label>
          <Input id="phone" value={phone} onChange={(e) => setPhone(e.target.value)} />
        </div>

        <div className="space-y-1">
          <Label htmlFor="product">מוצר</Label>
          <Input id="product" value={product} onChange={(e) => setProduct(e.target.value)} />
        </div>

        <div className="space-y-1">
          <Label htmlFor="comments">הערות</Label>
          <Textarea id="comments" value={comments} onChange={(e) => setComments(e.target.value)} />
        </div>

        <div className="space-y-1">
          <Label>תגים</Label>
          <AutocompleteTagInput selectedTags={selectedTags} setSelectedTags={setSelectedTags} />
        </div>
      </div>

      {errorMsg && <p className="text-sm text-destructive">{errorMsg}</p>}

      <div className="flex gap-2 justify-end">
        {onClose && (
          <Button variant="ghost" onClick={onClose} disabled={submitting}>
            ביטול
          </Button>
        )}
        <Button onClick={handleAddOrder} disabled={submitting} className="min-w-28">
          {submitting ? "שולח…" : "הוסף הזמנה"}
        </Button>
      </div>
    </div>
  );
}

/**
 * Full-page usage (keeps your route-based page working)
 */
export default function InsertOrder() {
  return (
    <div className="min-h-screen bg-background px-4 py-6" dir="rtl">
      <div className="container mx-auto">
        <h1 className="mb-4 text-2xl font-bold">הוסף הזמנה חדשה</h1>
        <Card className="max-w-xl">
          <CardContent className="pt-6">
            <InsertOrderForm />
          </CardContent>
        </Card>
      </div>
    </div>
  );
}

/**
 * Elegant dialog usage inside Orders page:
 *
 * <InsertOrderDialog onCreated={(order)=> refetchOrders()} />
 */
export function InsertOrderDialog({ onCreated }) {
  const [open, setOpen] = useState(false);
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button>הוספת הזמנה</Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-lg" dir="rtl">
        <DialogHeader>
          <DialogTitle>הוספת הזמנה</DialogTitle>
          <DialogDescription>מלא את הפרטים הבאים ליצירת הזמנה חדשה.</DialogDescription>
        </DialogHeader>
        <InsertOrderForm onCreated={onCreated} onClose={() => setOpen(false)} />
      </DialogContent>
    </Dialog>
  );
}
